import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";
import React, { Component } from "react";
import { PropTypes } from "prop-types";
import noop from "lodash/noop";
import { CheckedProvider } from "../Context.js";
class SingleSelectGroup extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "handleValueChange", evt => {
      const {
        onValueChange,
        onChange
      } = this.props;
      onValueChange(evt.target.value, evt);
      onChange(evt);
    });
  }
  render() {
    const {
      children,
      value
    } = this.props;
    return /*#__PURE__*/React.createElement(CheckedProvider, {
      value: {
        onChange: this.handleValueChange,
        isChecked: childValue => childValue === value
      }
    }, children);
  }
}
_defineProperty(SingleSelectGroup, "defaultProps", {
  value: '',
  onChange: noop,
  onValueChange: noop
});
process.env.NODE_ENV !== "production" ? SingleSelectGroup.propTypes = {
  /**
   * One to many RadioButton components.
   */
  children: PropTypes.node,
  /**
   * The currently selected value.
   */
  value: PropTypes.string,
  /**
   * Callback for when user selects a value. Prefer to use `onValueChange`
   *
   * ```ts
   * type onChange = (evt: React.SyntheticEvent): void
   * ```
   */
  onChange: PropTypes.func,
  /**
   * Callback called when user selects a value. The `value` argument is the new value selected.
   *
   * ```ts
   * type onValueChange = (value: string, evt: React.SyntheticEvent): void
   * ```
   */
  onValueChange: PropTypes.func
} : void 0;
export default SingleSelectGroup;